import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CdCommonModule} from '../cd-common/cd-common.module';
import {AuthEffects} from './auth-store/auth.effects';
import * as fromAuthStore from './auth-store/auth.reducer';
import {LoginComponent} from './login/login.component';
import {TermsAndConditionsComponent} from './terms-and-conditions/terms-and-conditions.component';
import {ZkkSelectionComponent} from './zkk-selection/zkk-selection.component';
import {ZkkSelectionViewComponent} from './zkk-selection-view/zkk-selection-view.component';

@NgModule({
  imports: [
    CommonModule,
    // CdCommonModule must come after CommonModule because of the overriden Datepipe in CdCommonModule
    CdCommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('auth', fromAuthStore.authReducer),
    EffectsModule.forFeature([AuthEffects]),
    LoginComponent,
    TermsAndConditionsComponent,
    ZkkSelectionComponent,
    ZkkSelectionViewComponent
  ]
})
export class AuthModule {}
